import { render, staticRenderFns } from "./FoodEditor.vue?vue&type=template&id=4e1b71b2"
import script from "./FoodEditor.vue?vue&type=script&lang=js"
export * from "./FoodEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports